import { CSSProperties, ReactElement } from 'react';
import { Property } from 'csstype';
import { SelectInputOption } from '../selectInput/SelectInput';

export const GLOBAL_MIN_COLUMN_WIDTH = '6rem';

export interface TableRow {
    [field: string]: any;
}

export type ListingTableCellFormat = 'default' | 'money' | 'date';

export type FilterType = 'text' | 'dropdown' | 'date' | 'date-range' | 'money' | 'money-range' | 'checkbox';

export interface TextFilterData { type: 'text', value: string; placeholder: string; notIncludeInTotalFilters?: boolean}
export interface DropdownFilterData { type: 'dropdown', options: SelectInputOption[]; value: string | null | undefined; notIncludeInTotalFilters?: boolean}
export interface DateFilterData { type: 'date', value: any | null | undefined; notIncludeInTotalFilters?: boolean}
export interface DateRangeFilterData { type: 'date-range', value: ({ start: Date | null | undefined; end: Date | null | undefined; }) | null | undefined; notIncludeInTotalFilters?: boolean}
export interface MoneyFilterData { type: 'money', value: number | null | undefined, unitPrefix: string | undefined;notIncludeInTotalFilters?: boolean }
export interface MoneyRangeFilterData { type: 'money-range', value: ({ start: number | null | undefined; end: number | null | undefined; }) | null | undefined; unitPrefix: string | undefined; notIncludeInTotalFilters?: boolean }
export interface CheckboxFilterData { type: 'checkbox', value?: boolean, onChange: (x: any) => void; notIncludeInTotalFilters: boolean}

export type FilterData =
    TextFilterData
    | DropdownFilterData
    | DateFilterData
    | DateRangeFilterData
    | MoneyFilterData
    | MoneyRangeFilterData
    | CheckboxFilterData;

export interface ListingTableColumn<TRow> {
    field: keyof TRow;
    name: string;
    tooltip?: string;
    cellAlignment?: Property.TextAlign;
    cellStyle?: CSSProperties;
    columnCellClassName?: string;
    columnCellAlignment?: Property.TextAlign;
    width?: number;
    minWidth?: string | number;
    preventClick?: boolean;
    cellFormat?: ListingTableCellFormat;
    suffix?: string,
    hideOn?: string[]; // 'sm','md','lg','xl'
    filter?: FilterData;
    orderColumn?: string;
    hideOrderButton?: boolean;
    isDynamic?: boolean;
    isWorkExternalPart?: boolean;
    hide?: boolean;
    onInfoIconClick?: () => void;
    renderCell?: (row: TRow, column: ListingTableColumn<TRow>, index: number) => ReactElement | string;
}

export interface OrderData<T> {
    field: keyof T;
    orderColumn?: string;
    isOrderAsc: boolean;
}
